import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 1.5rem 0 0 0;
  text-align: center;

  p {
    margin: 0;
    font-size: 1rem;
  }
`;

export const Title = styled.h4`
  margin: 0 0 0.2rem 0;
  font-size: 1.1rem;
`;
